export const EXTENSION_PASSKEY_AUTH_PATH = '/auth/passkey/extension'
